import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-12 col-xxxl-6" }
const _hoisted_3 = { class: "card-select mt-10 mt-md-0 mb-10 mb-md-0 d-inline-block d-sm-flex align-items-center ps-10 pe-10 pt-5 pb-5" }
const _hoisted_4 = { class: "col-xxl-12 col-xxxl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WhatHappening = _resolveComponent("WhatHappening")!
  const _component_StatsBoxes = _resolveComponent("StatsBoxes")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Časové období:", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timeSelected) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => {_ctx.getDashboardData(_ctx.timeSelected);}),
          class: "form-select shadow-none fw-semibold rounded-0 test"
        }, [...(_cache[2] || (_cache[2] = [
          _createStaticVNode("<option value=\"day\" data-v-271a8601>Dnes</option><option value=\"week\" data-v-271a8601>Týden</option><option value=\"month\" data-v-271a8601>Měsíc</option><option value=\"30days\" data-v-271a8601>30 dní</option><option value=\"60days\" data-v-271a8601>60 dní</option><option value=\"90days\" data-v-271a8601>90 dní</option><option value=\"all\" data-v-271a8601>Všechno</option>", 7)
        ]))], 544), [
          [_vModelSelect, _ctx.timeSelected]
        ])
      ]),
      _createVNode(_component_WhatHappening, { welcomeData: _ctx.welcomeData }, null, 8, ["welcomeData"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_StatsBoxes, { statBoxesData: _ctx.statBoxesData }, null, 8, ["statBoxesData"])
    ])
  ]))
}